import moment from "moment";
import "moment/locale/es";
import { cuentaMask, dineroDisabledMask } from '../Components/Items'

moment.locale("es");

const reportedeCuentasPorCobrar = (values) => {
    const empresa = values.empresa
    const logoBiwo = values.logoBiwo;
    let filtrados = []
    if (values.fechaVencimiento) {
        filtrados.push([
            { text: 'Fecha de Corte:', style: 'subheader' },
            { text: moment(values.fechaVencimiento).format('DD/MM/YYYY'), style: 'textoChico' }
        ]);
    }

    // Gemelo de etiquetaFiltroVentaOnline (erp_backend/Utils/filtroVentaOnline.utils.js)
    const tipoDeVenta = values.filtroVentaOnline === 'ecommerce' ? 'Ecommerce' : values.filtroVentaOnline === 'normales' ? 'Normales' : null;
    if (tipoDeVenta) {
        filtrados.push([
            { text: 'Tipo de venta:', style: 'subheader' },
            { text: tipoDeVenta, style: 'textoChico' }
        ]);
    }

    if (values.clientes !== 0 && values.clientes && values.clientes.length > 0) {
        let textoFiltrado = ''
        values.clientes.map((valueCliente) => {
            textoFiltrado += `${(valueCliente.persona ? valueCliente.nombre : (valueCliente.nombre + ' ' + valueCliente.apellidoPaterno + ' ' + valueCliente.apellidoMaterno)) + valueCliente.razonSocial + " - " + valueCliente.rfc}\n`
            return null
        })
        filtrados.push([
            { text: 'Clientes:', style: 'subheader' },

            { text: textoFiltrado, style: 'textoChico' }
        ])
    }

    if (values.vendedores !== 0 && values.vendedores && values.vendedores.length > 0) {
        let textoFiltrado = ''
        values.vendedores.map((valueVendedores) => {
            textoFiltrado += `${valueVendedores.nombre +
                " " +
                valueVendedores.apellidoPaterno +
                " " +
                valueVendedores.apellidoMaterno}\n`
            return null
        })
        filtrados.push([
            { text: 'Vendedores:', style: 'subheader' },

            { text: textoFiltrado, style: 'textoChico' }
        ])
    }

    if (values.filtrarProyecto === 1) {
        let textoFiltrado = ''
        values.proyectos.map((valueProyectos) => {
            textoFiltrado += `${valueProyectos.nombre}\n`
            return null
        })
        filtrados.push([
            { text: 'Proyectos:', style: 'subheader' },

            { text: textoFiltrado, style: 'textoChico' }
        ])
    }

    if (values.filtrarProyecto === 2) {
        filtrados.push([
            { text: 'Unidad de Negocio:', style: 'subheader' },

            {
                text: `${cuentaMask(
                    values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 + values.unidadDeNegocio.nivel5
                ) +
                    " - " +
                    values.unidadDeNegocio.nombre}`, style: 'textoChico'
            }
        ])
    }
    /*
    let ventas = []

    let totalTotales = 0
    let totalAbonos = 0
    let totalSaldo = 0
    let totalVencido = 0
    let totalNoVencido = 0 */

    
    let grupos = [];
    let grupoActual = [];

    for (const venta of values.ventas) {
    const esVentaPrincipal = venta.folio && typeof venta.fechaFactura === 'string';

    if (esVentaPrincipal) {
        if (grupoActual.length > 0) {
        grupos.push(grupoActual);
        }
        grupoActual = [venta]; 
    } else {
        grupoActual.push(venta);
    }
    }
    
    if (grupoActual.length > 0) {
    grupos.push(grupoActual);
    }

    
    grupos.sort((a, b) => {
    const fechaA = moment(a[0].fechaFactura, "DD/MM/YYYY").toDate();
    const fechaB = moment(b[0].fechaFactura, "DD/MM/YYYY").toDate();
    return fechaA - fechaB;
    });

    
    values.ventas = grupos.flat();

    const ventasPorMoneda = {}; 
    //Separar las ventas por moneda 
    grupos.forEach(grupo => {
        // La moneda del grupo la define el Padre (índice 0)
        const cabeza = grupo[0];
        const monedaKey = cabeza.moneda || 'Sin moneda';
        
        if(!ventasPorMoneda[monedaKey]) {
            ventasPorMoneda[monedaKey] = []
        }
        ventasPorMoneda[monedaKey].push(...grupo);
    });


    //Generar N tablas para N monedas
    const tablasDinamicas = []

    let granTotalTotales = 0;
    let granTotalAbonos = 0;
    let granTotalSaldo = 0;
    let granTotalVencido = 0;
    let granTotalNoVencido = 0;

    Object.keys(ventasPorMoneda).forEach((monedaNombre) =>{
        const ventasDeEstaMoneda = ventasPorMoneda[monedaNombre];
        let filasTabla = [];

        // Totales por moneda
        let totalTotales = 0;
        let totalAbonos = 0;
        let totalSaldo = 0;
        let totalVencido = 0;
        let totalNoVencido = 0;

        // Filas de datos 
        for (const valueVenta of ventasDeEstaMoneda) {
            const properties = valueVenta.colorStyle ? { background: valueVenta.colorStyle } : {};
            
            const esVentaPrincipal = valueVenta.folio && moment(valueVenta.fechaFactura, "DD/MM/YYYY", true).isValid();

            if (esVentaPrincipal) {
                // Solo sumamos totales si es Padre
                totalTotales += valueVenta.total || 0;
                totalAbonos += valueVenta.totalPagado || 0;
                totalSaldo += valueVenta.saldo || 0;

                if (isNaN(valueVenta.fechaVencimiento)) {
                    if (moment(valueVenta.fechaVencimiento, "DD/MM/YYYY").isBefore(moment())) {
                        totalVencido += valueVenta.saldo || 0;
                    } else {
                        totalNoVencido += valueVenta.saldo || 0;
                    }
                }

                filasTabla.push([
                    { text: valueVenta.folio, style: 'textoTabla', alignment: 'left' },
                    { text: valueVenta.fechaFactura, style: 'textoTabla', alignment: 'center' },
                    { text: valueVenta.cliente, style: 'textoTabla', alignment: 'left' },
                    {
                        text: typeof valueVenta.fechaVencimiento === 'string' && moment(valueVenta.fechaVencimiento, "DD/MM/YYYY", true).isValid()
                            ? moment(valueVenta.fechaVencimiento, "DD/MM/YYYY").locale('es').format('L')
                            : '-',
                        style: 'textoTabla',
                        alignment: 'center'
                    },
                    { text: valueVenta.estado, ...properties, style: 'textoTabla', alignment: 'left' },
                    { text: valueVenta.vendedor, style: 'textoTabla', alignment: 'left' },
                    { text: dineroDisabledMask(valueVenta.totalPagar), style: 'textoTabla', alignment: 'right' },
                    { text: dineroDisabledMask(valueVenta.totalPagado), style: 'textoTabla', alignment: 'right' },
                    { text: dineroDisabledMask(valueVenta.saldo), style: 'textoTabla', alignment: 'right' },
                ]);

            } else {

                filasTabla.push([
                    { text: '', style: 'textoTablaInsumo' }, 
                    { text: valueVenta.fechaFactura, style: 'textoTablaInsumo', alignment: 'center' }, // Cantidad
                    { text: valueVenta.cliente, style: 'textoTablaInsumo', alignment: 'left', colSpan: "2" }, // Descripción
                    {},
                    { text: '', style: 'textoTtextoTablaInsumoabla' },
                    { text: dineroDisabledMask(valueVenta.total), style: 'textoTablaInsumo', alignment: 'right' }, //Precio unitario
                    { text: dineroDisabledMask(valueVenta.estado), style: 'textoTablaInsumo', alignment: 'right' }, 
                    { text: dineroDisabledMask(valueVenta.totalPagado), style: 'textoTablaInsumo', alignment: 'right' },
                    { text: dineroDisabledMask(valueVenta.saldo), style: 'textoTablaInsumo', alignment: 'right' },
                ]);
            }
        }

        granTotalTotales += totalTotales;
        granTotalAbonos += totalAbonos;
        granTotalSaldo += totalSaldo;
        granTotalVencido += totalVencido;
        granTotalNoVencido += totalNoVencido;

        //Fila de totales
        if (totalTotales > 0 || totalAbonos > 0 || totalSaldo > 0) {
            filasTabla.push([
                { text: 'Totales (' + monedaNombre + '):', style: 'totalesTabla', alignment: 'left', colSpan: 6 }, // Antes 7, ahora 6
                {}, {}, {}, {}, {},
                { text: dineroDisabledMask(totalTotales), style: 'totalesTabla', alignment: 'right' },
                { text: dineroDisabledMask(totalAbonos), style: 'totalesTabla', alignment: 'right' },
                { text: dineroDisabledMask(totalSaldo), style: 'totalesTabla', alignment: 'right' },
            ], [
                { text: 'Total Vencido (' + monedaNombre + '):', style: 'totalesTabla', alignment: 'left', colSpan: 6 },
                {}, {}, {}, {}, {},
                { text: dineroDisabledMask(totalVencido), style: 'totalesTabla', alignment: 'right', colSpan: 3 },
                {}, {}
            ], [
                { text: 'Total No Vencido (' + monedaNombre + '):', style: 'totalesTabla', alignment: 'left', colSpan: 6 },
                {}, {}, {}, {}, {},
                { text: dineroDisabledMask(totalNoVencido), style: 'totalesTabla', alignment: 'right', colSpan: 3 },
                {}, {}
            ]);
        }

        // Estructura de la tabla para esta moneda
        tablasDinamicas.push(
            // Título de la moneda
            { text: `Moneda: ${monedaNombre}`, style: 'monedaTitle', margin: [0, 10, 0, 5] },
            
            // La tabla
            {
                style: 'tableExample',
                table: {
                    widths: ['6%', '10%', '16%', '10%', '8%', '11%', '12%', '12%', '15%'], 
                    headerRows: 1,
                    layout: {
                        defaultBorder: true,
                    },
                    body: [
                        [
                            { text: 'Folio', style: 'tituloTabla' },
                            { text: 'Fecha', style: 'tituloTabla' },
                            { text: 'Cliente', style: 'tituloTabla' },
                            { text: 'Vencimiento', style: 'tituloTabla' },
                            { text: 'Estado', style: 'tituloTabla' },
                            { text: 'Vendedor', style: 'tituloTabla' },
                            // { text: 'Moneda', style: 'tituloTabla' }, 
                            { text: 'Total', style: 'tituloTabla' },
                            { text: 'Abonos', style: 'tituloTabla' },
                            { text: 'Saldo', style: 'tituloTabla' },
                        ],
                        ...filasTabla
                    ]
                },
                layout: {
                    fillColor: (rowIndex, node, columnIndex) => {
                        return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
                    },
                    hLineWidth: function (i, node) { return (i === 0 || i === node.table.body.length) ? 1 : 1; },
                    vLineWidth: function (i, node) { return (i === 0 || i === node.table.widths.length) ? 1 : 1; },
                    hLineColor: function (i, node) { return '#adaaaa'; },
                    vLineColor: function (i, node) { return '#adaaaa'; },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) { return null; }
                        return { dash: { length: 2, space: 1 } };
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) { return null; }
                        return { dash: { length: 2 } };
                    }
                }
            }
        );
    });

    tablasDinamicas.push({
        style: 'tableExample',
        table: {
            widths: ['6%', '10%', '16%', '10%', '8%', '11%', '12%', '12%', '15%'],
            body: [
                [
                    { text: 'GRAN TOTAL:', style: 'totalesTabla', alignment: 'left', colSpan: 6, fillColor: '#aaaaaa' },
                    {}, {}, {}, {}, {},
                    { text: dineroDisabledMask(granTotalTotales), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
                    { text: dineroDisabledMask(granTotalAbonos), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
                    { text: dineroDisabledMask(granTotalSaldo), style: 'totalesTabla', alignment: 'right', fillColor: '#aaaaaa' },
                ],
                [
                    { text: 'GRAN TOTAL VENCIDO:', style: 'totalesTabla', alignment: 'left', colSpan: 6, fillColor: '#aaaaaa' },
                    {}, {}, {}, {}, {},
                    { text: dineroDisabledMask(granTotalVencido), style: 'totalesTabla', alignment: 'right', colSpan: 3, fillColor: '#aaaaaa' },
                    {}, {}
                ],
                [
                    { text: 'GRAN TOTAL NO VENCIDO:', style: 'totalesTabla', alignment: 'left', colSpan: 6, fillColor: '#aaaaaa' },
                    {}, {}, {}, {}, {},
                    { text: dineroDisabledMask(granTotalNoVencido), style: 'totalesTabla', alignment: 'right', colSpan: 3, fillColor: '#aaaaaa' },
                    {}, {}
                ],
            ]
        },
        layout: { hLineWidth: () => 1, vLineWidth: () => 1, hLineColor: () => '#aaaaaa', vLineColor: () => '#aaaaaa' }
    });

    if (filtrados.length === 0) {
        filtrados.push([
            { text: 'No tiene filtrados adicionales', style: 'subheader' },
            { text: '', style: 'textoChico' }
        ])
    }
    /*
    for (const valueVenta of values.ventas) {
        const properties = valueVenta.colorStyle ? { background: valueVenta.colorStyle } : {}
        totalTotales += valueVenta.total
        totalAbonos += valueVenta.totalPagado
        totalSaldo += valueVenta.saldo

        if (isNaN(valueVenta.fechaVencimiento)) {
            if (moment(valueVenta.fechaVencimiento, "DD/MM/YYYY").isBefore(moment())) {
                totalVencido += valueVenta.saldo
            } else {
                totalNoVencido += valueVenta.saldo
            }
        }

        ventas.push([
            { text: valueVenta.folio, style: 'textoTabla', alignment: 'left' },
            { text: isNaN(valueVenta.fechaFactura) ? moment(valueVenta.fechaFactura, "DD/MM/YYYY").locale('es').format('L') : valueVenta.fechaFactura, style: 'textoTabla', alignment: 'center' },
            { text: valueVenta.cliente, style: 'textoTabla', alignment: 'left' },
            { 
                text: typeof valueVenta.fechaVencimiento === 'string' &&
                      moment(valueVenta.fechaVencimiento, "DD/MM/YYYY", true).isValid()
                  ? moment(valueVenta.fechaVencimiento, "DD/MM/YYYY").locale('es').format('L')
                  : '-',
                style: 'textoTabla', 
                alignment: 'center' 
              },
            { text: valueVenta.estado, ...properties, style: 'textoTabla', alignment: 'left' },
            { text: valueVenta.vendedor, style: 'textoTabla', alignment: 'left' },
            { text: valueVenta.moneda, style: 'textoTabla', alignment: 'left' },
            { text: dineroDisabledMask(valueVenta.totalPagar), style: 'textoTabla', alignment: 'right' },
            { text: dineroDisabledMask(valueVenta.totalPagado), style: 'textoTabla', alignment: 'right' },
            { text: dineroDisabledMask(valueVenta.saldo), style: 'textoTabla', alignment: 'right' },
        ])
    }

    if (totalTotales > 0 || totalAbonos > 0 || totalSaldo > 0) {
        ventas.push([
            { text: 'Totales:', style: 'totalesTabla', alignment: 'left', colSpan: 7 },
            {},
            {},
            {},
            {},
            {},
            {},
            { text: dineroDisabledMask(totalTotales), style: 'totalesTabla', alignment: 'right' },
            { text: dineroDisabledMask(totalAbonos), style: 'totalesTabla', alignment: 'right' },
            { text: dineroDisabledMask(totalSaldo), style: 'totalesTabla', alignment: 'right' },
        ], [
            { text: 'Total Vencido:', style: 'totalesTabla', alignment: 'left', colSpan: 7 },
            {},
            {},
            {},
            {},
            {},
            {},
            { text: dineroDisabledMask(totalVencido), style: 'totalesTabla', alignment: 'right', colSpan: 3 },
            {},
            {},
        ], [
            { text: 'Total No Vencido:', style: 'totalesTabla', alignment: 'left', colSpan: 7 },
            {},
            {},
            {},
            {},
            {},
            {},
            { text: dineroDisabledMask(totalNoVencido), style: 'totalesTabla', alignment: 'right', colSpan: 3 },
            {},
            {},
        ])
    }*/

    if (filtrados.length === 0) {
        filtrados.push([
            { text: 'No tiene filtrados adicionales', style: 'subheader' },

            { text: '', style: 'textoChico' }
        ])
    }

    var dd = {
        footer: {
            image: 'logoBiwo', alignment: 'center', width: 80
        },
        content: [
            {
                style: 'tableExample',
                table: {
                    widths: ['18%', '52%', '30%'],
                    layout: {
                        defaultBorder: false,
                    },
                    body: [
                        [
                            {
                                //							rowSpan: 3,
                                border: [false, false, false, false],
                                image: 'logo',
                                fit: [80, 80]
                                //text: 'rowSpan: 3\n\nborder:\n[true, true, true, true]'
                            },
                            {
                                //	rowSpan: 2,
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1,
                                    widths: ['100%'],

                                    body: [
                                        [
                                            {
                                                text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre+' '+empresa.apellidoPaterno+' '+empresa.apellidoMaterno),
                                                style: "tableHeader"
                                            }
                                        ],
                                        [
                                            {
                                                text: "R.F.C: " + empresa.rfc,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [
                                            {
                                                text: empresa.calle + ' ' +
                                                    empresa.numeroCalle + ' ' +
                                                    (empresa.numeroInterior ? empresa.numeroInterior : '')
                                                ,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [
                                            {
                                                text: empresa.colonia.tipoAsentamiento + ' ' +
                                                    empresa.colonia.nombre + ' C.P. ' +
                                                    empresa.colonia.cp + ' ' +
                                                    empresa.municipio.nombre + ' ' +
                                                    empresa.estado.abreviatura + ' ' +
                                                    empresa.pais.abreviatura + ' '
                                                ,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [{ text: 'REPORTE DE CUENTAS POR COBRAR', style: 'tableHeader' }],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                            {
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1,
                                    widths: ['100%'],

                                    body: [
                                        [{ text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center' }],
                                        [{ text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center' }],
                                        [{ text: 'Desglose:', style: 'subheader', alignment: 'center' }],
                                        [{ text: values.detalle ? 'Si' : 'No', style: 'textoChico', alignment: 'center' }],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                        ]

                    ]
                },
            },
            { text: 'Datos de filtrado:' },
            {
                style: 'tableExample',
                table: {
                    widths: ['20%', '80%'],
                    layout: {
                        defaultBorder: false,
                    },

                    body: filtrados,
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    vLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return null;
                        }
                        return { dash: { length: 2, space: 1 } };
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) {
                            return null;
                        }
                        return { dash: { length: 2 } };
                    },
                    // paddingLeft: function(i, node) { return 4; },
                    // paddingRight: function(i, node) { return 4; },
                    // paddingTop: function(i, node) { return 2; },
                    // paddingBottom: function(i, node) { return 2; },
                    // fillColor: function (i, node) { return null; }
                }

            },
            /*
            {
                style: 'tableExample',
                table: {
                    widths: ['6%', '10%', '16%', '10%',  '8%', '10%', '7%', '11%', '10%', '12%'],
                    layout: {
                        defaultBorder: true,
                    },
                    body: [
                        [
                            { text: 'Folio', style: 'tituloTabla' },
                            { text: 'Fecha', style: 'tituloTabla' },
                            { text: 'Cliente', style: 'tituloTabla' },
                            { text: 'Vencimiento', style: 'tituloTabla' },
                            { text: 'Estado', style: 'tituloTabla' },
                            { text: 'Vendedor', style: 'tituloTabla' }, 
                            { text: 'Moneda', style: 'tituloTabla' },
                            { text: 'Total', style: 'tituloTabla' },
                            { text: 'Abonos', style: 'tituloTabla' },
                            { text: 'Saldo', style: 'tituloTabla' },
                        ],
                        //Falta esto en el backend y ya
                        ...ventas,
                    ]
                },
                layout: {
                    fillColor: (rowIndex, node, columnIndex) => {
                        return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
                    },
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    vLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return null;
                        }
                        return { dash: { length: 2, space: 1 } };
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) {
                            return null;
                        }
                        return { dash: { length: 2 } };
                    },
                    // paddingLeft: function(i, node) { return 4; },
                    // paddingRight: function(i, node) { return 4; },
                    // paddingTop: function(i, node) { return 2; },
                    // paddingBottom: function(i, node) { return 2; },
                    // fillColor: function (i, node) { return null; }
                }
            },
            */
            ...tablasDinamicas,
            
        ],
        images: {
            logo: empresa.logo.base64Completa,
            logoBiwo: logoBiwo.base64Completa,
        },
        styles: {
            header: {
                fontSize: 9,
                bold: true,
            },
            subheader: {
                fontSize: 8,
                bold: true,
            },
            monedaTitle: {
                fontSize: 12,
                bold: true,
            },
            tableExample: {
                margin: [0, 5, 0, 5]
            },
            tablaSinMargen: {
                margin: [0, 0, 0, 0]
            },
            tableHeader: {
                bold: true,
                fontSize: 12,
                color: 'black',
                alignment: 'center'
            },
            textoChico: {
                fontSize: 8
            },
            tituloTabla: {
                fontSize: 8,
                bold: true,
                fillColor: '#cccccc',
                style: 'subheader',
                alignment: 'center',
                border: true
            },
            textoTabla: {
                fontSize: 8,
                italics: false
            },
            totalesTabla: {
                fontSize: 8,
                bold: true,
                italics: false,
                fillColor: '#cccccc',
            },
            textoTablaInsumo: { 
                fontSize: 7, 
                italics: true,
                color: "#666666"
            },
        },
        pageSize: 'LETTER',
        pageMargins: [20, 20, 20, 60],
    }
    return dd;
};




export default reportedeCuentasPorCobrar;
